/**
 * @generated SignedSource<<b29f642c1bd9bd188946bd667575c3ed>>
 * @relayHash 9137f6ba8103daa1f8fc1cb16d05720b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9137f6ba8103daa1f8fc1cb16d05720b

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PatientFileLockAction = "ALLOWED" | "CANCEL_REQUEST" | "DENIED" | "RELEASED" | "REQUESTED" | "REQUEST_COUNTDOWN" | "TAKEN";
export type usePatientFileLockChangeSubscription$variables = {
  patientId: string;
};
export type usePatientFileLockChangeSubscription$data = {
  readonly patientFileLockChanged: {
    readonly action: PatientFileLockAction;
    readonly lock: {
      readonly appointment: {
        readonly chatDetails: {
          readonly chatThreadId: string;
        } | null;
      } | null;
      readonly lockedBy: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"requestTakeOverDialog_patientFileLockFragment">;
    };
    readonly takeOverRequestCountdownValue: number | null;
  };
};
export type usePatientFileLockChangeSubscription = {
  response: usePatientFileLockChangeSubscription$data;
  variables: usePatientFileLockChangeSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "patientId",
    "variableName": "patientId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedBy",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AppointmentChatDetails",
  "kind": "LinkedField",
  "name": "chatDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chatThreadId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "action",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "takeOverRequestCountdownValue",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePatientFileLockChangeSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PatientFileLockChange",
        "kind": "LinkedField",
        "name": "patientFileLockChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientFileLock",
            "kind": "LinkedField",
            "name": "lock",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "requestTakeOverDialog_patientFileLockFragment"
              },
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Appointment",
                "kind": "LinkedField",
                "name": "appointment",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "usePatientFileLockChangeSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PatientFileLockChange",
        "kind": "LinkedField",
        "name": "patientFileLockChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientFileLock",
            "kind": "LinkedField",
            "name": "lock",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "patientId",
                "storageKey": null
              },
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockRequestedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockRequestedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Appointment",
                "kind": "LinkedField",
                "name": "appointment",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "takenAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startingSoonNotificationSent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCompleted",
                    "storageKey": null
                  },
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "9137f6ba8103daa1f8fc1cb16d05720b",
    "metadata": {},
    "name": "usePatientFileLockChangeSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "6a4669ddb25c25ac5cc3742a3a0906d2";

export default node;
